import React, { useState } from 'react'
import styled from 'styled-components'
import Popover from '@mui/material/Popover'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { ROLE_EXPLANATIONS } from 'utils/roles'

const RolesExplainer = () => {
  const [anchor, setAnchor] = useState(null)

  return (
    <>
      <InfoButton type='button' aria-label='What the roles mean' onClick={e => { e.stopPropagation(); setAnchor(e.currentTarget) }}>
        <InfoOutlinedIcon fontSize='small' />
      </InfoButton>
      <Popover open={Boolean(anchor)} anchorEl={anchor} onClose={() => setAnchor(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
        <Panel>
          <Title>What the roles mean</Title>
          {ROLE_EXPLANATIONS.map(role => (
            <Row key={role.key}>
              <RoleName>{role.label}</RoleName>
              <RoleText>{role.text}</RoleText>
            </Row>
          ))}
        </Panel>
      </Popover>
    </>
  )
}

export default RolesExplainer

const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
  border: 0;
  background: transparent;
  color: #475467;
  cursor: pointer;
`

const Panel = styled.div`
  max-width: 360px;
  padding: 16px;
`

const Title = styled.h3`
  margin: 0 0 8px;
  font-size: 16px;
`

const Row = styled.div`
  padding: 8px 0;
  border-top: 1px solid #eaecf0;
`

const RoleName = styled.div`
  font-weight: 600;
  font-size: 15px;
`

const RoleText = styled.div`
  font-size: 15px;
  line-height: 1.5;
  color: #344054;
`
